import logo from '../images/hrp-logo.svg';

function Nav() {
  return (
    <div className="navbar navbar-dark bg-dark navbar-expand-md py-0">
      <div className="container">
        <a href="/" className="navbar-brand">
          <img src={logo} alt="Logo" />
        </a>
      </div>
    </div>
  );
}

export default Nav;
